import * as React from 'react';
import { useLocation } from 'react-router';

import { variantUrlFromUrl } from '@notino/shared/client-utils';
import { AvailabilityState } from '@notino/shared/definitions/types';
import { AdditionalServicesAvailability } from '@notino/web-tracking';

import { useTrackingDisplayType } from '@containers/ProductDetailContainer/utils';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import { useProductDetailContext } from '../../ProductDetailContext';
import { useIsSkinAnalyzerVisible } from '../ProductBaseInfo/SkinAnalyser/hooks/useIsSkinAnalyzerVisible';
import { useResolvedVoucherDiscount } from '../ProductBaseInfo/VoucherDiscount/useResolvedVoucherDiscount';
import { trackItemInExponea, trackPageReload } from '../tracking';

import { usePriceLogic } from './usePriceLogic';

export const useTrackItemAndReload = () => {
  const { pathname } = useLocation();
  const variantUrl = variantUrlFromUrl(pathname);
  const featureFlags = useFeatureFlags();
  const shouldShowSkinAnalyzer = useIsSkinAnalyzerVisible();

  const {
    additionalServices,
    engravingAvailable,
    tryItFirstAvailable,
    currentVariant: variant,
    product,
  } = useProductDetailContext();

  const { rrpShown, minimalPriceShown } = usePriceLogic(variant);

  const trackingDisplayType = useTrackingDisplayType(product);
  const hasVoucher = !!useResolvedVoucherDiscount();

  // Did update variantUrl
  React.useEffect(() => {
    const trackPageView =
      variant.availability.state !== AvailabilityState.CanBeBought ||
      additionalServices?.data?.CartServicesIncluded ||
      additionalServices?.error;

    const eventPayload = {
      variant,
      product,
      engravingAvailable:
        engravingAvailable ?? AdditionalServicesAvailability.notAvailable,
      tryItFirstAvailable:
        tryItFirstAvailable ?? AdditionalServicesAvailability.notAvailable,
      skinAnalyzer: shouldShowSkinAnalyzer,
      hasVoucher,
    };

    if (trackPageView) {
      trackItemInExponea(product, variant);
      trackPageReload({
        rrpShown,
        minimalPriceShown,
        trackingDisplayType,
        featureFlags,
        ...eventPayload,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variantUrl, additionalServices.loading]);
};
